<template>
  <div class="barra-acesso" v-if="!error && getData.length > 0">
    <Carousel
      ref="nav"
      :autoplay="true"
      :nav="true"
      :dots="false"
      :items="4"
      :responsive="{
        0: {
          items: 1,
          nav: false,
        },
        360: {
          items: 2,
          nav: false,
        },
        600: {
          items: 3,
          nav: false,
        },
        900: {
          items: 4,
          nav: false,
        },
      }"
    >
      <template slot="prev">
        <div class="ba-prev">
          <span class="prev">&lsaquo;</span>
        </div>
      </template>
      <Card v-for="(item, idx) in getData" :key="idx" :data="item" />
      <template slot="next">
        <div class="ba-next">
          <span class="next">&rsaquo;</span>
        </div>
      </template>
    </Carousel>
  </div>
  <div class="barra-acesso-not-found" v-else></div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Carousel from 'vue-owl-carousel';
import Card from './Card';

export default {
  name: 'BarraAcesso',
  components: { Carousel, Card },
  computed: {
    ...mapGetters({
      getData: 'barraAcesso/data',
      error: 'barraAcesso/error',
    }),
  },
  methods: {
    ...mapActions({
      barraAcessoInit: 'barraAcesso/init',
    }),
  },
  beforeMount() {
    this.barraAcessoInit();
  },
};
</script>

<style lang="scss">
@import '@/estilo/sass/_formulas.scss';
@import '@/estilo/sass/_cores.scss';

.barra-acesso-not-found {
  position: relative;
  width: 980px;
  height: auto;
  margin: 0 auto;
  padding: 20px 0;
  z-index: 0;

  border-bottom: 1px solid $cor_cinza_medium;
}

.barra-acesso {
  position: relative;
  width: 980px;
  height: auto;
  margin: 0 auto;
  padding: 20px 0;
  z-index: 0;

  border-bottom: 1px solid $cor_cinza_medium;

  & .ba-prev,
  .ba-next {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    position: absolute;
    top: 0;
    z-index: 99;
    user-select: none;
    color: $cor_roxo;
    font-size: 40px;
    line-height: 0px;

    cursor: pointer;
    transition: all 0.3s ease-in-out;
  }

  & .ba-prev {
    left: -13px;

    -webkit-animation: shake-right 1.7s cubic-bezier(0.455, 0.03, 0.515, 0.955)
      infinite both;
    animation: shake-right 1.7s cubic-bezier(0.455, 0.03, 0.515, 0.955) infinite
      both;
  }

  & .ba-next {
    right: -13px;

    -webkit-animation: shake-left 1.7s cubic-bezier(0.455, 0.03, 0.515, 0.955)
      infinite both;
    animation: shake-left 1.7s cubic-bezier(0.455, 0.03, 0.515, 0.955) infinite
      both;
  }
}

@media all and (min-width: 300px) and (max-width: 1000px) {
  .barra-acesso {
    width: 100%;
    height: auto;
    border: 0px;
    background: white;
    padding: 20px 0 0;
  }

  .barra-acesso-not-found {
    padding: 0;
    width: 100%;
    height: auto;
    background: white;
    border: 0;
  }
}

@-webkit-keyframes shake-left {
  0%,
  100% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transform-origin: 0 50%;
    transform-origin: 0 50%;
  }
  10% {
    -webkit-transform: rotate(2deg);
    transform: rotate(2deg);
  }
  20%,
  40%,
  60% {
    -webkit-transform: rotate(-4deg);
    transform: rotate(-4deg);
  }
  30%,
  50%,
  70% {
    -webkit-transform: rotate(4deg);
    transform: rotate(4deg);
  }
  80% {
    -webkit-transform: rotate(-2deg);
    transform: rotate(-2deg);
  }
  90% {
    -webkit-transform: rotate(2deg);
    transform: rotate(2deg);
  }
}
@keyframes shake-left {
  0%,
  100% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transform-origin: 0 50%;
    transform-origin: 0 50%;
  }
  10% {
    -webkit-transform: rotate(2deg);
    transform: rotate(2deg);
  }
  20%,
  40%,
  60% {
    -webkit-transform: rotate(-4deg);
    transform: rotate(-4deg);
  }
  30%,
  50%,
  70% {
    -webkit-transform: rotate(4deg);
    transform: rotate(4deg);
  }
  80% {
    -webkit-transform: rotate(-2deg);
    transform: rotate(-2deg);
  }
  90% {
    -webkit-transform: rotate(2deg);
    transform: rotate(2deg);
  }
}

@-webkit-keyframes shake-right {
  0%,
  100% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transform-origin: 100% 50%;
    transform-origin: 100% 50%;
  }
  10% {
    -webkit-transform: rotate(2deg);
    transform: rotate(2deg);
  }
  20%,
  40%,
  60% {
    -webkit-transform: rotate(-4deg);
    transform: rotate(-4deg);
  }
  30%,
  50%,
  70% {
    -webkit-transform: rotate(4deg);
    transform: rotate(4deg);
  }
  80% {
    -webkit-transform: rotate(-2deg);
    transform: rotate(-2deg);
  }
  90% {
    -webkit-transform: rotate(2deg);
    transform: rotate(2deg);
  }
}
@keyframes shake-right {
  0%,
  100% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transform-origin: 100% 50%;
    transform-origin: 100% 50%;
  }
  10% {
    -webkit-transform: rotate(2deg);
    transform: rotate(2deg);
  }
  20%,
  40%,
  60% {
    -webkit-transform: rotate(-4deg);
    transform: rotate(-4deg);
  }
  30%,
  50%,
  70% {
    -webkit-transform: rotate(4deg);
    transform: rotate(4deg);
  }
  80% {
    -webkit-transform: rotate(-2deg);
    transform: rotate(-2deg);
  }
  90% {
    -webkit-transform: rotate(2deg);
    transform: rotate(2deg);
  }
}
</style>
